// Dynamic manifest generation for event-specific PWAs
export const generateManifest = (event) => {
  const baseManifest = {
    id: `/${event.slug}`,
    name: event?.name,
    short_name: event?.name?.split(" ").slice(0, 2).join(" "),
    description: `${event.name} - Your AI copilot & event app`,
    // theme_color: event?.theme_color,
    background_color: "#ffffff",
    display: "standalone",
    orientation: "portrait",
    scope: `${window.location.origin}/e/${event.slug}/`,
    start_url: `${window.location.origin}/e/${event.slug}/copilot`,
    categories: ["event"],
    lang: "en",
    dir: "ltr",
  };

  // Add event-specific icon if available
  // Replace the default icons with event-specific ones
  baseManifest.icons = [
    {
      src: event.logo_url,
      sizes: "192x192",
      type: "image/png",
      purpose: "any maskable",
    },
    {
      src: event.logo_url,
      sizes: "512x512",
      type: "image/png",
      purpose: "any maskable",
    },
    {
      src: event.logo_url,
      sizes: "180x180",
      type: "image/png",
      purpose: "any",
    },
    {
      src: event.logo_url,
      sizes: "167x167",
      type: "image/png",
      purpose: "any",
    },
    {
      src: event.logo_url,
      sizes: "152x152",
      type: "image/png",
      purpose: "any",
    },
    {
      src: event.logo_url,
      sizes: "120x120",
      type: "image/png",
      purpose: "any",
    },
  ];

  return baseManifest;
};

// Update the manifest link in the document head
export const updateManifest = (event) => {
  const manifest = generateManifest(event);

  // Remove existing manifest link first
  const existingManifestLink = document.querySelector('link[rel="manifest"]');
  if (existingManifestLink) {
    existingManifestLink.remove();
  } else {
  }

  // Create new manifest link
  const manifestLink = document.createElement("link");
  manifestLink.rel = "manifest";
  document.head.appendChild(manifestLink);

  // Use a data URL instead of blob URL for better PWA compatibility
  const manifestJSON = JSON.stringify(manifest, null, 2);
  const manifestURL = `data:application/json;charset=utf-8,${encodeURIComponent(
    manifestJSON
  )}`;
  manifestLink.href = manifestURL;

  // Update theme color meta tag
  let themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (!themeColorMeta) {
    themeColorMeta = document.createElement("meta");
    themeColorMeta.name = "theme-color";
    document.head.appendChild(themeColorMeta);
  }
  // themeColorMeta.content = manifest.theme_color;

  // Update title
  document.title = manifest.name;

  // Update iOS-specific meta tags for better PWA support
  let appleMobileWebAppTitle = document.querySelector(
    'meta[name="apple-mobile-web-app-title"]'
  );
  if (!appleMobileWebAppTitle) {
    appleMobileWebAppTitle = document.createElement("meta");
    appleMobileWebAppTitle.name = "apple-mobile-web-app-title";
    document.head.appendChild(appleMobileWebAppTitle);
  }
  appleMobileWebAppTitle.content = manifest.short_name;

  // Ensure status bar style is set to black for white background
  let statusBarStyle = document.querySelector(
    'meta[name="apple-mobile-web-app-status-bar-style"]'
  );
  if (!statusBarStyle) {
    statusBarStyle = document.createElement("meta");
    statusBarStyle.name = "apple-mobile-web-app-status-bar-style";
    document.head.appendChild(statusBarStyle);
  }
  statusBarStyle.content = "black";

  // Update description meta tag
  let descriptionMeta = document.querySelector('meta[name="description"]');
  if (!descriptionMeta) {
    descriptionMeta = document.createElement("meta");
    descriptionMeta.name = "description";
    document.head.appendChild(descriptionMeta);
  }
  descriptionMeta.content = manifest.description;

  return manifestURL;
};

// Clean up manifest URL when component unmounts
export const cleanupManifest = (manifestURL) => {
  if (manifestURL) {
    URL.revokeObjectURL(manifestURL);
  }
};
